import React from 'react';
import { Col, FormFeedback, Form, FormGroup, Input, Label, InputGroup, ModalBody, ModalFooter, Row } from 'reactstrap'
import Select from 'react-select';

export const FormUnitConversion = (props) => {

    const { toggle, loading, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, methodAction } = props;

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            cursor: 'pointer',
            borderRadius: '12px',
            borderColor: state.isFocused
                ? '#46AFE5'
                : '#dbe4f0',
            boxShadow: state.isFocused
                ? '0 0 0 3px rgba(70,175,229,.15)'
                : 'none',
            fontSize: '12px',
            transition: 'all .2s ease',
            '&:hover': {
                borderColor: '#46AFE5'
            }

        }),

        option: (provided, state) => ({
            ...provided,

            cursor: 'pointer',
            backgroundColor: state.isSelected
                ? '#46AFE5'
                : state.isFocused
                    ? '#eef7fd'
                    : '#fff',
            color: state.isSelected ? '#fff' : '#334155',
        }),

        placeholder: (provided) => ({
            ...provided,
            color: '#94a3b8'
        }),

        menuPortal: (base) => ({
            ...base,
            zIndex: 999999
        }),

        menu: (provided) => ({
            ...provided,
            zIndex: 999999,
            position: 'absolute'
        }),


    };

    return (
        <Form role="form" className='pt-3' onSubmit={methodAction}>
            <div className='form-section'>
                {/* <div className="form-title-container">
                    <h4 className="form-title-custom">
                        Configuración de unidades de conversión
                    </h4>
                </div> */}
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className="label-custom">
                                Unidad de origen <span className="label-required"> *</span>
                            </Label>

                            <Select
                                classNamePrefix="select"
                                name="id_unit_from"
                                options={units.map((u) => ({
                                    value: u.id_unit,
                                    label: `${u.unit} (${u.abbreviation})`
                                }))}

                                value={
                                    units
                                        .map((u) => ({
                                            value: u.id_unit,
                                            label: `${u.unit} (${u.abbreviation})`
                                        }))
                                        .find((opt) =>
                                            opt.value === id_unit_from
                                        ) || null
                                }

                                placeholder="Selecciona una opción"
                                isClearable={false}

                                onChange={(e) =>
                                    handleInputChange({
                                        target: {
                                            name: "id_unit_from",
                                            value: e ? e.value : ""
                                        }
                                    })
                                }

                                styles={customSelectStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />

                            <FormFeedback>
                                Debes seleccionar una opción
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                    <Col md="12">
                        <FormGroup>
                            <Label className="label-custom">
                                Unidad de destino <span className="label-required"> *</span>
                            </Label>

                            <Select
                                classNamePrefix="select"
                                name="id_unit_to"
                                options={units.map((u) => ({
                                    value: u.id_unit,
                                    label: `${u.unit} (${u.abbreviation})`
                                }))}

                                value={
                                    units
                                        .map((u) => ({
                                            value: u.id_unit,
                                            label: `${u.unit} (${u.abbreviation})`
                                        }))
                                        .find((opt) =>
                                            opt.value === id_unit_to
                                        ) || null
                                }

                                placeholder="Selecciona una opción"
                                isClearable={false}

                                onChange={(e) =>
                                    handleInputChange({
                                        target: {
                                            name: "id_unit_to",
                                            value: e ? e.value : ""
                                        }
                                    })
                                }

                                styles={customSelectStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />

                            <FormFeedback>
                                Debes seleccionar una opción
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                    <Col md="12">
                        <FormGroup>
                            <Label className="label-custom">
                                Factor de conversión
                            </Label>

                            <Input
                                type="number"
                                autoComplete="off"
                                name="conversion_factor"
                                value={conversion_factor}
                                onChange={handleInputChange}
                                placeholder="Ej. 0.001 o 1000"
                                className="input-custom"
                            />
                        </FormGroup>

                        <FormFeedback>
                            Debes llenar este campo
                        </FormFeedback>

                    </Col>

                </Row>
            </div>
        </Form>
    )
}
